import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ErrorMessage } from 'ng-bootstrap-form-validation';
import { MainService } from '../../../../services';
import { ModPass } from '../../../../models';

@Component({
  selector: 'app-dialog-cambia-password',
  templateUrl: './dialog-cambia-password.component.html',
  styleUrls: ['./dialog-cambia-password.component.css']
})
export class DialogCambiaPassword implements OnInit {

  formGroup: FormGroup;
  modPass: ModPass;
  errore: boolean;
  erroreMsg: string;

  constructor(public dialogRef: MatDialogRef<DialogCambiaPassword>,
    private mainService: MainService) { }

  ngOnInit() {
    this.modPass = new ModPass();
    this.formGroup = new FormGroup({
      password: new FormControl('', [
        Validators.required, Validators.minLength(8), Validators.pattern(/^[&-_.!,0-9a-zA-Zèàùòéì]{1,}$/)
      ], [ this.confermaPassword.bind(this), this.validatePasswords.bind(this) ]),
      oldPassword: new FormControl('', [
        Validators.required, Validators.minLength(8), Validators.pattern(/^[&-_.!,0-9a-zA-Zèàùòéì]{1,}$/)
      ], [ this.validatePasswords.bind(this) ])
    });
  }

  confermaPassword(control: FormControl): { [key: string]: any } {
    return new Promise(resolve => {
      if (this.modPass.newPassword !== this.modPass.cNewPassword) {
        resolve({ 'non-uguali': true });
      }
      else resolve(null);
    });
  }

  validatePasswords(control: FormControl): { [key: string]: any } {
    return new Promise(resolve => {
      if (this.modPass.newPassword === this.modPass.oldPassword) {
        resolve({ 'pass-uguali': true });
      }
      else resolve(null);
    });
  }

  updatePassword() {
    if (this.formGroup.valid) {
      this.mainService.tokenExpiredService.ifTokenNotExpired().subscribe(
        response => {
          if(response) {
            this.mainService.profiloService.updatePassword(this.modPass).subscribe(
              response => {
                if(response.status === 200){
                  this.errore = false;
                  this.dialogRef.close();
                  this.mainService.alertService.success('Password modificata con successo.');
                } else {
                  this.errore = true;
                  this.erroreMsg = 'Errore ' + response.status + ': Non è stato possibile modificare la password!';
                }
              }, error => {
                if(error.status === 401){
                  this.errore = true;
                  this.erroreMsg = 'Errore: verificare la password!';
                } else {
                  this.errore = true;
                  this.erroreMsg = 'Errore ' + error.status + ': Non è stato possibile modificare la password!';
                }
                
              }
            )
          }
      });
    }
  }

  passwordErrorMessage: ErrorMessage[] = [
    { error: 'required', format: (label, error) => `${label} è un campo obbligatorio!` }, 
    { error: 'minlength', format: (label, error) => `${label} deve essere lunga almeno 8 caratteri` },
    { error: 'pattern', format: (label, error) => `Caratteri speciali consentiti: &-_.!,` },
    { error: 'non-uguali', format: (label, error) => `non sono uguali` },
    { error: 'pass-uguali', format: (label, error) => `la nuova password è uguale a quella vecchia` }
  ];

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-cambia-password/dialog-cambia-password.component.ts